import { localField } from "../../_emywork/helpers/UIHelper";
//used for formik fom inputs like AEInput
export const formFields = (formik, getFieldProps) => (name, label, type) => {
  let p = {
    name,
    label,
    field: getFieldProps(name),
    form: formik,
  };

  switch (type) {
    case "autocomplete":
      p.useId = true;
      p.getOptionLabel = (o) => o[localField()];

      break;
    default:
      break;
  }

  return p;
};

export const getFilterProps = ({ formik, getFieldProps }) => (name) => {
  return {
    name: name,
    variant: "standard",
    withFeedbackLabel: false,
    validation: false,
    field: getFieldProps(name),
    form: formik,
  };
};
